import { jsx } from "react/jsx-runtime";
import {
  Select,
  modalClasses,
  outlinedInputClasses,
  selectClasses,
  styled,
  useThemeProps
} from "@mui/material";
import { forwardRef } from "react";
const editorToolbarSelectName = "TidalEditorToolbarSelect";
const editorToolbarSelectClasses = selectClasses;
const EditorToolbarSelectBase = forwardRef(function EditorToolbarSelectBase2(inProps, ref) {
  const props = useThemeProps({
    name: editorToolbarSelectName,
    props: inProps
  });
  const { size = "small", testId = `${editorToolbarSelectName}-root`, autoWidth = true, MenuProps, ...rest } = props;
  return /* @__PURE__ */ jsx(
    Select,
    {
      ref,
      size,
      autoWidth,
      MenuProps: {
        sx: {
          [`.${modalClasses.backdrop}`]: {
            backgroundColor: "transparent"
          },
          ...MenuProps?.sx
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "left",
          ...MenuProps?.anchorOrigin
        },
        MenuListProps: {
          disablePadding: true,
          ...MenuProps?.MenuListProps
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left",
          ...MenuProps?.transformOrigin
        },
        ...MenuProps
      },
      "data-tidal": editorToolbarSelectName,
      "data-testid": testId,
      ...rest
    }
  );
});
const EditorToolbarSelect = styled(EditorToolbarSelectBase, {
  name: editorToolbarSelectName,
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})(({ disabled }) => ({
  [`.${outlinedInputClasses.notchedOutline}`]: {
    border: 0
  },
  ...disabled && {
    backgroundColor: "revert"
  }
}));
export {
  EditorToolbarSelect,
  editorToolbarSelectClasses,
  editorToolbarSelectName
};
//# sourceMappingURL=EditorToolbarSelect.js.map
